/**
 * Created by nijin on 5/6/17.
 */
import {Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {RemoveIPConfirmationComponent} from '../modal/remove.ip.confirmation';
import {RegenerateKeyConfirmationComponent} from '../modal/regenerate.key.confirmtaion';
import {DeleteKeyConfirmationComponent} from '../modal/delete.key.confirmation';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify/index';
import {ApiKeyService} from '../../api-key.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'nuc-key',
  templateUrl: './display-key.html',
  styleUrls: ['./display-key.scss']
})
export class DisplayKeyComponent implements OnInit, OnChanges {

  public form: FormGroup;
  public isLoading = false;
  public isCopied = false;
  public isSubmitted = false;

  @ViewChild('removeIp') removeIpPopup: RemoveIPConfirmationComponent;
  @ViewChild('regenKey') regenKeyPopup: RegenerateKeyConfirmationComponent;
  @ViewChild('delete') deleteKeyPopup: DeleteKeyConfirmationComponent;

  @Input() apiKeys: any;
  @Input() activeApiKey: any;

  @Output() onKeyDelete: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onKeyRegenerate: EventEmitter<any> = new EventEmitter<any>();
  validationMessages = {
    'ip': {
      'required':  'API_KEY.IP_VALIDATION.REQUIRED',
      'pattern': 'API_KEY.IP_VALIDATION.PATTERN',
    },
    'description': {
      'maxlength': 'API_KEY.IP_VALIDATION.DESCRIPTION',
    }
  };

  formErrors = {
    'ip': '',
    'description': '',
  };

  constructor(private apiKeyService: ApiKeyService,
              private notifier: NotificationBarService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.buildForm();
  }

  ngOnChanges() {
    this.isCopied = false;
  }

  private buildForm() {
    this.form = this.fb.group({
      'ip': ['', [
        Validators.required,
        Validators.pattern('^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.)' +
          '{3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\\/(\\d|[1-2]\\d|3[0-2]))$')
      ]],
      'description': ['', [
        Validators.maxLength(100)

      ]]
    });

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  
  removeIpConfirmation(ip) {
    this.removeIpPopup.open(ip);
  }

  regenerateKey() {
    this.regenKeyPopup.open();
  }

  deleteKey() {
    this.deleteKeyPopup.open();
  }

  onDeleteConfirmation(event) {
     this.onKeyDelete.emit(true);
  }

  onKeyRegenerated(event) {
     this.onKeyRegenerate.emit(event);
  }

  addWhiteListedIp(form) {
    this.isSubmitted = true;
    const data = {
      timeToLive:  -1,
      whitelistIps:  []
    };
    this.onValueChanged();
    if  (form.valid)  {
      if  (this.activeApiKey.whitelistIps.map(key => key.ip).indexOf(form.value.ip) > -1) {
        this.formErrors.ip = 'API_KEY.IP_VALIDATION.ALREADY_ADDED';
        return;
      }
      this.isLoading = true;
      data.whitelistIps = [...this.activeApiKey.whitelistIps, form.value];
      this.apiKeyService.updateWhiteListedIp(this.activeApiKey.id, data)
        .subscribe((response) => {
          this.activeApiKey.whitelistIps.unshift(form.value);
          this.notifier.create({type: NotificationType.Success, message: response.status.message});
          form.reset();
          this.isSubmitted = false;
          this.isLoading = false;
        }, (error) => {
          this.notifier.create({type: NotificationType.Error, message: error});
          this.isLoading = false;
        });
    }

  }

  onIpRemoved(response) {
    this.activeApiKey = response;
  }

  onValueChanged(data?: any) {
    if (!this.form) { return; }
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }





}



// WEBPACK FOOTER //
// ./src/app/accounts/api-key/sub/display-key.component.ts